<template>
  <b-form-select
      v-model="selectedOptions"
      multiple
      taggable
      @input="atualizaOpcao"
  >
    <option
        v-for="option in options"
        :key="option.id"
        :value="option"
    >
      {{ option.name }}
    </option>
  </b-form-select>
</template>

<script>
export default {
  data() {
    return {
      selectedOptions: [], // Array vazio para armazenar as opções selecionadas
      options: [
        { id: 1, name: 'Opção 1' },
        { id: 2, name: 'Opção 2' },
        { id: 3, name: 'Opção 3' }
      ],
    };
  },
  methods: {
    atualizaOpcao() {
      // Lógica para atualizar as opções selecionadas
    },
  },
};
</script>
